<template>
  <div>
    <!--  配送単導入詳細情報画面 -->
    <t-card v-loading="loading">
      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.ReceOrderSelectDialog.colOneSpan'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                :data="cc"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                border
                fit
              >
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :width="
                    column.prop !== 'aodProdRemarksSum'
                      ? column.realWidth
                      : getRemarksColumnWidthProc()
                  "
                  :min-width="
                    column.prop !== 'aodProdRemarksSum'
                      ? column.width
                      : undefined
                  "
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="
                    column.prop === 'aodProdRemarksSum'
                      ? true
                      : column.overflowTooltip
                  "
                >
                  <template #default="scope">
                    <template v-if="column.prop === 'aodProdRemarksSum'">
                      <div class="bikouDiv">
                        <!-- 備考表示 -->
                        <span class="bikouText">
                          {{ scope.row.aodProdRemarksSum }}
                        </span>
                      </div>
                    </template>

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  formatRemarksShow,
  getDialogContentHeight,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
export default {
  data() {
    return {
      cc: [],
      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(window.innerHeight, 20, 0, 0),

      //合計情報のheight
      bottomHeight: 10 * 1,

      // 待つ
      loading: true,

      columns: [
        // NO.
        {
          prop: "indexNo",
          label: "NO.",
          realWidth: t("widgetSize.tableCommon.width50"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        {
          // 订单号
          prop: "jrdOrderNoShow",
          label: "手配No.",
          realWidth: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.checkReceInfo.crdProductName"),
          realWidth: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.checkReceInfo.crdPictureNo"),
          realWidth: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 異常区分
        {
          prop: "prodExKbn",
          label: t("resource.checkReceInfo.exceptionKbn"),
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 数量
        {
          prop: "jrdReceQty",
          label: "数量",
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // NG数
        {
          prop: "jrdReceNgQty",
          label: "NG数",
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // OK数
        {
          prop: "jrdReceOkQty",
          label: "OK数",
          realWidth: t("widgetSize.tableCommon.width90"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },

        // 備考
        {
          label: t("resource.REMARKS_ADD.REMARKS"),
          class: "cell_txt_center",
          prop: "aodProdRemarksSum",
          min_width: 100,
          scopedSlots: {
            default: "aodProdRemarksSum",
          },
        },
      ],

      //現在選択されているセル
      currentCell: [],
    };
  },

  props: {
    jpReceByDeliveryDtos: {
      Type: Object,
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    this.jpReceByDeliveryDtos.forEach((item) => {
      this.cc.push(item);
    });

    // 初期化
    this.init();

    // 根据 errMessage 的长度动态添加列
    this.updateColumnsBasedOnErrMessage();
  },

  computed: {},

  methods: {
    // 初期化
    init() {
      this.loading = false;
    },

    //确定ボタン
    confirmClick() {
      this.loading = true;

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.jpReceByDeliveryDtos);
    },

    handleResize() {
      const dialogBody = document.querySelector(".el-dialog__body");

      if (dialogBody) {
        const height = dialogBody.offsetHeight;
        this.detailHeight = height - 50;
      } else {
        this.detailHeight = window.innerHeight * 0.7;
      }
    },

    updateColumnsBasedOnErrMessage() {
      const data = this.cc;
      if (data && data.length > 0) {
        // 找到最大的 errMessage 数量
        let maxErrMessageLength = 0;

        data.forEach((item) => {
          if (item.errMessage && item.errMessage.length > maxErrMessageLength) {
            maxErrMessageLength = item.errMessage.length;
          }
        });

        // 创建对应的列
        for (let i = 0; i < maxErrMessageLength; i++) {
          this.$set(this.columns, this.columns.length, {
            prop: `errMessage${i}`,
            label: `異常 ${i + 1}`,
            width: "200",
            class: "cell_txt_left",
            overflowTooltip: false,
            columnValue: "1",
          });
        }

        // 为每条数据设置对应列的值
        data.forEach((item) => {
          if (item.errMessage) {
            item.errMessage.forEach((message, index) => {
              item[`errMessage${index}`] = message;
            });
          }
        });
      }
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.cc);
    },
  },
};
</script>
<style scoped>
.el-form-item__label.custom-label {
  width: 20%;
}

.left-align {
  justify-content: left !important;
}
</style>
